
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[projectId]/surveys/[surveyId]/pinned",
      function () {
        return require("private-next-pages/[projectId]/surveys/[surveyId]/pinned.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[projectId]/surveys/[surveyId]/pinned"])
      });
    }
  